import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-08b2224f"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "general" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("legend", null, [
  /*#__PURE__*/_createElementVNode("b", null, "Detalles de Cliente")
], -1))
const _hoisted_3 = { class: "form-group" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "form-label mt-4" }, [
  /*#__PURE__*/_createElementVNode("b", null, "Datos Generales")
], -1))
const _hoisted_5 = { class: "grid" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "No: ", -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "Tipo: ", -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "RNC / Cédula: ", -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "Nombre: ", -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "Descripción: ", -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "Dirección: ", -1))
const _hoisted_12 = { class: "form-group" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "form-label mt-4" }, [
  /*#__PURE__*/_createElementVNode("b", null, "Datos de Contacto")
], -1))
const _hoisted_14 = { class: "grid" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "Teléfonos: ", -1))
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "Emails: ", -1))
const _hoisted_17 = { class: "form-group" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "form-label mt-4" }, [
  /*#__PURE__*/_createElementVNode("b", null, "Datos Tributarios")
], -1))
const _hoisted_19 = { class: "grid" }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "Razón Social: ", -1))
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "Tipo Persona: ", -1))
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "Tipo Comprobante: ", -1))
const _hoisted_23 = { class: "form-group" }
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "form-label mt-4" }, [
  /*#__PURE__*/_createElementVNode("b", null, "Otros")
], -1))
const _hoisted_25 = { class: "grid" }
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "Observaciones: ", -1))
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "Estatus: ", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("form", null, [
      _createElementVNode("fieldset", null, [
        _hoisted_2,
        _createElementVNode("div", _hoisted_3, [
          _hoisted_4,
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("h6", null, [
              _hoisted_6,
              _createTextVNode(_toDisplayString(_ctx.currentCliente.no), 1)
            ]),
            _createElementVNode("h6", null, [
              _hoisted_7,
              _createTextVNode(_toDisplayString(_ctx.currentCliente.tipo), 1)
            ]),
            _createElementVNode("h6", null, [
              _hoisted_8,
              _createTextVNode(_toDisplayString(_ctx.currentCliente.rnc), 1)
            ]),
            _createElementVNode("h6", null, [
              _hoisted_9,
              _createTextVNode(_toDisplayString(_ctx.currentCliente.nombre), 1)
            ]),
            _createElementVNode("h6", null, [
              _hoisted_10,
              _createTextVNode(_toDisplayString(_ctx.currentCliente.descripcion), 1)
            ]),
            _createElementVNode("h6", null, [
              _hoisted_11,
              _createTextVNode(_toDisplayString(_ctx.currentCliente.direccion), 1)
            ]),
            _createElementVNode("div", _hoisted_12, [
              _hoisted_13,
              _createElementVNode("div", _hoisted_14, [
                _createElementVNode("h6", null, [
                  _hoisted_15,
                  _createTextVNode(_toDisplayString(_ctx.currentCliente.telefonos), 1)
                ]),
                _createElementVNode("h6", null, [
                  _hoisted_16,
                  _createTextVNode(_toDisplayString(_ctx.currentCliente.email), 1)
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_17, [
              _hoisted_18,
              _createElementVNode("div", _hoisted_19, [
                _createElementVNode("h6", null, [
                  _hoisted_20,
                  _createTextVNode(_toDisplayString(_ctx.currentCliente.razonSocial), 1)
                ]),
                _createElementVNode("h6", null, [
                  _hoisted_21,
                  _createTextVNode(_toDisplayString(_ctx.currentCliente.tipoPersona), 1)
                ]),
                _createElementVNode("h6", null, [
                  _hoisted_22,
                  _createTextVNode(_toDisplayString(_ctx.currentCliente.tipoComprobante), 1)
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_23, [
              _hoisted_24,
              _createElementVNode("div", _hoisted_25, [
                _createElementVNode("h6", null, [
                  _hoisted_26,
                  _createTextVNode(_toDisplayString(_ctx.currentCliente.observaciones), 1)
                ]),
                _createElementVNode("h6", null, [
                  _hoisted_27,
                  _createTextVNode(_toDisplayString(_ctx.currentCliente.estatus), 1)
                ])
              ])
            ])
          ])
        ])
      ])
    ])
  ]))
}